import React from "react";
import { View, Modal, Animated } from "react-native";

import Toast from "component/toast";

import { sizes, colors } from "asset/constant";
import { css } from "style";

type ConfirmAlertT = {
  show: boolean;
  force?: boolean;
  showToast?: boolean;
  hide: () => void;
  renderContent: (close: () => void) => JSX.Element;
};

export default function ConfirmAlert(props: ConfirmAlertT) {
  const { show, hide, renderContent, force, showToast } = props;

  const animVar = React.useRef(new Animated.Value(0)).current;

  const startAnimate = React.useCallback(
    () =>
      Animated.spring(animVar, {
        toValue: 1,
        bounciness: 10,
        speed: 3,
        useNativeDriver: true,
      }).start(),
    [animVar]
  );

  const close = () => {
    animVar.setValue(0);
    hide();
  };

  const boxScale = animVar.interpolate({
    inputRange: [0, 1],
    outputRange: [0.6, 1],
  });

  return (
    <Modal
      animationType="fade"
      onShow={startAnimate}
      visible={show}
      transparent
      onRequestClose={force ? undefined : close}
    >
      <View
        style={[
          css.container,
          css.centralElements,
          css.bgColor(colors.modal_bg.dark_glass),
        ]}
      >
        {renderContent && (
          <Animated.View
            style={[
              {
                width: "85%",
                maxWidth: 400,
              },

              css.bgColor(colors.white),
              css.radius(sizes.radius.md),
              {
                transform: [{ scale: boxScale }],
                paddingHorizontal: sizes.space,
                paddingVertical: 2 * sizes.space,
              },
            ]}
          >
            {renderContent(close)}
          </Animated.View>
        )}
      </View>
      {showToast && <Toast.Provider />}
    </Modal>
  );
}
